import { render, staticRenderFns } from "./HealthProfessionalModal.vue?vue&type=template&id=663e1122&"
import script from "./HealthProfessionalModal.vue?vue&type=script&lang=ts&"
export * from "./HealthProfessionalModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports